

























import Vue from 'vue';
import ReportTable from '@/components/ReportTable.vue';
import ReportControls, {ReportSpecByWeek, Account} from '@/components/ReportControls.vue';
import axios from 'axios';
import XLSX from 'xlsx';
import { DateTime } from "luxon";

export default Vue.extend({
    name: 'CustomerProductMix',
    components: {ReportControls, ReportTable},
    data() {
        return {
            loading: true,
            spec: {} as ReportSpecByWeek,
            headers: [],
            selectedPeriod: [],
            yearToDate: [],
        };
    },
    computed: {
        dataUrl(): string {
            const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';
            if (this.spec.dateStyle === "calendar") {
              const {depot, from, to} = this.spec;
              return `${BASE_URL}/reports/customer-product-mix/${depot}/${DateTime.fromJSDate(from).toISODate()}/${DateTime.fromJSDate(to).toISODate()}/`;
            } else {
              const {depot, from, to} = this.spec;
              return `${BASE_URL}/reports/customer-product-mix/${depot}/${from.year}/${from.week}/${to.year}/${to.week}/`;
            }
        },
    },
    watch: {
        async spec() {
            this.loading = true;
            const response = await axios.get(this.dataUrl, {
                params: {
                    account_codes: this.spec.accountCodes.flatMap((a: Account) => a.codes),
                },
            });
            this.headers = response.data.headers;
            this.selectedPeriod = response.data.results.currentWeek;
            this.yearToDate = response.data.results.yearToDate;
            this.loading = false;
        },
    },
    methods: {
        download() {
            const wb = XLSX.utils.book_new();
            const currentWeekSheet = XLSX.utils.table_to_sheet((this.$refs.currentWeek as Vue).$el);
            const yearToDateSheet = XLSX.utils.table_to_sheet((this.$refs.yearToDate as Vue).$el);
            XLSX.utils.book_append_sheet(wb, currentWeekSheet, 'Current Week');
            XLSX.utils.book_append_sheet(wb, yearToDateSheet, 'Year to Date');
            const {depot, from, to} = this.spec;
            XLSX.writeFile(wb, `Customer Product Mix for Depot ${depot} - ${from.year}${to.week} to ${to.year}${to.week}.xlsx`);
        },
    },
});
